import React from 'react'
import { Flex } from '@chakra-ui/react'

export const Tr = React.forwardRef((props, ref) => {
  return (
    <Flex
      ref={ref}
      display='flex'
      flex='1 0 auto'
      alignItems='center'
      _notLast={{ borderBottomWidth: '1px' }}
      _hover={{ color: 'brand.500' }}
      {...props}
    />
  )
})
